import React, {useState, useRef, useEffect} from "react"
import "./UserLogIn.css"
import {Link} from "react-router-dom"
import BackgroundImage from "../../assets/img/recruitment-homepage-images/background.png";
import Logo from "../../assets/img/logo/logo.png";
import LogIn from "../../assets/img/logIn/logIn.jpg";
import LogInWithLogo from "../../assets/img/logIn/Login-fotografija.png"
import {authenticate, getAuthResource, updateAuthResource} from "../service/http-service";

export const UserLogIn = () => {
    const [reset, setReset] = useState(false);
    const [loginInfo, setLoginInfo] = useState({});
    const [viewNewPass, setViewNewPass] = useState(true)
    const [error, setError] = useState(false)
    const [backError, setBackError] = useState("")
    const [forgottenPasswordUsername, setForgottenPasswordUsername] = useState('')
    const [confirmMessage, setConfirmMessage] = useState('')

    const LoginRef = useRef(null);

    const goToLoginForm = () =>
        window.scrollTo({
            top: LoginRef.current.offsetTop,
            behavior: "auto",
        });

    useEffect(() => {
        if(sessionStorage.getItem("confirmMessage")){
            setConfirmMessage(sessionStorage.getItem('confirmMessage'))
        }
        sessionStorage.removeItem('confirmMessage')
    },[])

    return (
        <div className="container-fluid m-0 p-0">
            <div className="row m-0 p-0 backgroundImage">
                <img src={BackgroundImage} className="backgroundImage m-0 p-0" alt="background-image" onLoad={() => goToLoginForm()}/>
                <div className="col-md-10 offset-md-1 col-12">
                    <div className="row m-0 p-0">
                        <div className="col-md-4 col-7 main-title">
                            АПЛИКАЦИЈА ЗА КАРИЕРА
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mx-3 p-0" >
                <div className="col-md-10 offset-md-1 p-0 logIn-container">
                    <img src={Logo} className="logIn-logo"/>
                    <img src={LogIn} className="logIn-img" onLoad={() => goToLoginForm()}/>
                    <div className="logIn-content" style={{backgroundImage: `url(${LogInWithLogo})`}}>
                        <div className="form-container">
                            {reset ?  <div className="basic-info">
                                    <form className="form-body">
                                        <div className="form-title">
                                            <h2>Ресетирај лозинка</h2>
                                        </div>
                                        <input type="text"
                                               required={true}
                                               value={forgottenPasswordUsername}
                                               placeholder="Корисничко име"
                                               onChange={(e) => {
                                                setForgottenPasswordUsername(e.target.value)}}/>
                                        <br/>
                                        {backError && <small>{backError}</small>}
                                        <div className="d-flex justify-content-around">
                                            <button onClick={()=> setReset(false)} className="logIn-btn" >Назад</button>
                                            <button  className="logIn-btn" type="button" onClick={()=> {
                                                (forgottenPasswordUsername !== "") &&
                                                updateAuthResource('user/renew_password', forgottenPasswordUsername)
                                                    .then(data => {
                                                    console.log(data.data);
                                                    setReset(false)
                                                    setConfirmMessage("Пратен е меил за промена на лозинка")
                                                }).catch((exception) => {
                                                    setBackError(exception.response.data.message);
                                                })
                                            }}
                                            >Ресетирај</button>
                                        </div>
                                    </form>
                                </div> :
                                <div className="basic-info" >
                                    <div className="form-title">
                                        <h2 >Најави се</h2>
                                    </div>
                                     <div className="pass-inputs">
                                         <input type="text" required={true} placeholder="*Корисничко име"
                                                value={loginInfo.username}
                                                onChange={(e) => {
                                                    setError(false)
                                                    setBackError('')
                                                    setLoginInfo({...loginInfo, username: e.target.value})}}
                                         />
                                         <br/>
                                     </div>
                                    <div className="pass-inputs">
                                        <input  type={viewNewPass ? "password" : "text"} placeholder="*Лозинка"  id="pass"
                                                value={loginInfo.password}
                                                onChange={(e) =>{
                                                    setError(false)
                                                    setLoginInfo({...loginInfo, password: e.target.value})
                                                }}
                                        />
                                        <i onClick={()=> setViewNewPass(!viewNewPass)}
                                           className={viewNewPass ? "fa fa-eye text-white" : "fa fa-eye-slash text-white" }/>
                                    </div>
                                       <br/>
                                       <div className="text-center">
                                           {((!backError || backError==='')  && error) &&  <small className="text-white">Невалидна лозинка</small>}
                                           <br/>
                                           {backError && <small>{backError}</small>}
                                           <br/>
                                           {confirmMessage && <small>{confirmMessage}</small>}
                                       </div>
                                       <div className="d-flex justify-content-center">
                                           <button className="main-logIn-btn"
                                                   onClick={(e)=> {
                                                       authenticate('user/authenticate', loginInfo)
                                                           .then((data)=> {
                                                               console.log('data vo avtentikacija');
                                                               console.log(data.data);
                                                               let user = {};
                                                               user.username = data.data.username;
                                                               user.accessToken = data.data.accessToken;
                                                               sessionStorage.setItem("user", JSON.stringify(user));
                                                               getAuthResource('user/check_change_password').then((data) => {
                                                                   sessionStorage.setItem("changePassword", JSON.stringify(data.data));
                                                                   sessionStorage.removeItem('confirmMessage')
                                                                   window.location.replace("/career_opportunities/profile")
                                                               })
                                                           }).catch((exception)=> {
                                                           setBackError(exception.response.data.message)
                                                           setError(true)
                                                       })
                                                   }}
                                           >Најава</button>
                                       </div>
                                    <br/>
                                    <div className="text-center d-flex justify-content-around btn-container">
                                        <Link className="logIn-form-link">
                                            <button className="logIn-btn logIn-btn2" onClick={()=> setReset(true)}>Заборавена лозинка</button>
                                        </Link>
                                        <Link to="/career_opportunities/registration" className="logIn-form-link">
                                            <button className="logIn-btn logIn-btn2">Креирај кориснички профил</button>
                                        </Link>
                                    </div>
                                </div>}
                        </div>
                    </div>
                    <div ref={LoginRef} className="white-space"></div>
                </div>
            </div>
        </div>
    )
};